export default __webpack_public_path__ + "static/media/central_andes_1_7.5b498f5a.JPG";